import { Satellite } from "@material-ui/icons";
import {
    SET_ERROR, 
    SET_LOADING,
    CLEAR_ERROR,
    STOP_LOADING,
    SET_USER,
    SET_MESSAGE,
    CLEAR_MESSAGE,
    SET_UNAUTHENTICATED
  } from "../actions/types";
  
  
  const initialState = {
      loading: false,
      errors: null,
      stripeVisibility: false,
      snackBar: null
  }
  export default function (state = initialState, action) {
    const { type, payload } = action;
  
    switch (type) {
      case SET_UNAUTHENTICATED:
        return {
          ...state,
          errors: null,
          loading: false,
          snackBar: null 
        };
      case SET_ERROR:
        return {
          ...state,
          errors: payload,
          loading: false,
          snackBar: payload && payload.message ? { message: payload.message, type: 'error' } : null 
        };
     case CLEAR_ERROR:
        return {
          ...state,
          errors: null,
          loading: false,
          snackBar: null
        };
     case SET_LOADING:
        return {
          ...state,
          loading: true  
        };
    case STOP_LOADING:
        return {
          ...state,
          loading: false  
        };
    case SET_USER:
        return {
          ...state,
          loading: false,
          errors: null
        }  
    case SET_MESSAGE:
      console.log(payload)
        return {
          ...state,
          snackBar: payload
        } 
      case CLEAR_MESSAGE:
        return {
          ...state,
          snackBar: null
        } 
      default:
        return state;
    }
  }